import axios from 'axios';
import {
  fetchSensorsStart,
  fetchSensorsSuccess,
  fetchSensorsFailure,
  createSensorSuccess,
  createSensorFailure,
  updateWaterLevelSensorStart,
  updateWaterLevelSensorSuccess,
  updateWaterLevelSensorFailure,
  updateAlarmSettingsFailure,
  updateAlarmSettingsSuccess,
  updateAlarmSettingsStart,
} from './sensorSlice';
import { API_BASE_URL } from '../config/config';

// Fetch sensors for a specific device
export const fetchSensorsForDevice = (deviceId) => async (dispatch, getState) => {
  dispatch(fetchSensorsStart());
  try {
    const { token } = getState().user; // Get JWT token from user state
    const response = await axios.get(`${API_BASE_URL}api/sensor/${deviceId}/sensors`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    dispatch(fetchSensorsSuccess(response.data.sensors));
  } catch (error) {
    dispatch(fetchSensorsFailure(error.response?.data?.message || 'Failed to fetch sensors for device'));
  }
};

// Create a new sensor for a specific device
export const createSensor = (newSensorData) => async (dispatch, getState) => {
  try {
    const { token } = getState().user;
    const response = await axios.post(`${API_BASE_URL}api/sensor/addsensor`, newSensorData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    dispatch(createSensorSuccess(response.data.sensor));
    return response; // Return the response in case you want to handle it in the component
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to create sensor';
    dispatch(createSensorFailure(errorMessage)); // Dispatch error message
    throw new Error(errorMessage); // Throw an error so the component can catch it
  }
};
export const updateWaterLevelSensor = (deviceCode, sensorSubId, updatedSensorData) => async (dispatch, getState) => {
  dispatch(updateWaterLevelSensorStart());
  try {
    const { token } = getState().user; // Get JWT token from user state
    const response = await axios.patch(
      `${API_BASE_URL}api/sensor/sensors/${deviceCode}/${sensorSubId}/water-level`,
      updatedSensorData,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch(updateWaterLevelSensorSuccess(response.data.sensor));
    return response.data.sensor; // Return the updated sensor to be used in the component if needed
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to update sensor';
    dispatch(updateWaterLevelSensorFailure(errorMessage));
  }
};
export const updateFlowMeterSettings = (deviceCode, sensorSubId, settings) => async (dispatch) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}api/sensor/water-flow-meter/${deviceCode}/${sensorSubId}/functional-points`,
      settings
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error updating flow meter settings');
  }
};

export const updateFlowMeterAlarmSettings = (deviceCode, sensorSubId, alarmSettings) => async (dispatch) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}api/sensor/water-flow-meter/${deviceCode}/${sensorSubId}/alarm-settings`,
      alarmSettings
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error updating flow meter alarm settings');
  }
};

export const updateAlarmSettings = (deviceCode, sensorSubId, updatedAlarmData) => async (dispatch, getState) => {
  dispatch(updateAlarmSettingsStart());
  try {
    const { token } = getState().user; // Get JWT token from user state
    const response = await axios.patch(
      `${API_BASE_URL}api/sensor/sensors/${deviceCode}/${sensorSubId}/alarm-settings`,
      updatedAlarmData,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch(updateAlarmSettingsSuccess(response.data.sensor));
    return response.data.sensor; // Return the updated sensor if needed
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to update alarm settings';
    dispatch(updateAlarmSettingsFailure(errorMessage));
  }
};